import { createSelector } from 'reselect';
import { UserPhone, UserPhoneType } from '@centecomm/portal-service';

import AccountState from './Types';
import { State } from '../../Types';

const accountState = ({ account }: State) => account;

const accountPhoneNumbers = createSelector(accountState, ({ phoneNumbers }: AccountState): UserPhone[] => phoneNumbers);

const hasMobileNumber = createSelector(accountPhoneNumbers, (phoneNumbers) => phoneNumbers.some(phoneNumber => phoneNumber.phoneType === UserPhoneType.Mobile));

export default {
    accountPhoneNumbers,
    hasMobileNumber
};
